// extracted by mini-css-extract-plugin
export default {"container":"point-item-support-logs_container__-J3NR","title":"point-item-support-logs_title__yaZMS"};